import { render } from "./DriveAllFiles.vue?vue&type=template&id=4323aff6&scoped=true&ts=true"
import script from "./DriveAllFiles.vue?vue&type=script&lang=ts"
export * from "./DriveAllFiles.vue?vue&type=script&lang=ts"

import "./DriveAllFiles.vue?vue&type=style&index=0&id=4323aff6&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4323aff6"]])

export default __exports__